import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DataRowOutlet } from '@angular/cdk/table';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../services/common.service';
import { TabChangeService } from '../services/tab-change.service';
import { W700servicesService } from '../services/w700services.service';
declare var $
declare const copyToClipboard: any;
@Component({
  selector: 'app-varules',
  templateUrl: './varules.component.html',
  styleUrls: ['./varules.component.scss']
})

export class VarulesComponent implements OnInit, OnDestroy {

  @Input() inputDataInModalComponent: any;
  @ViewChild('referenceBackdropTpl') referenceBackdropTpl: ElementRef<HTMLElement>;
  @ViewChild('referencePanelTpl') referencePanelTpl: ElementRef<HTMLElement>;
  activeReferenceRule: any = null;
  referencePanelTop = 0;
  referencePanelLeft = 0;
  private readonly referencePanelWidth = 335;
  varuleObj: any = {};
  isLoadingcase: boolean;
  rulename: string = '';
  LabId: any;
  isShown : boolean;
  LabName: any;
  LabOrgId: any;
  LabOrgName: any;
  OrdFacilityId: any;
  OrdFacilityName: any;
  OrdFacOrgId: any;
  OrdFacOrgName: any;
  InterfaceName: any;
  isflag: any;
  Islocked: any;
  enableedit:boolean=true;
  Mode:string ="";
  // Modal tracking for nested modals
  private destroy$ = new Subject<void>();
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  constructor(private activeModal: NgbActiveModal,
    private w700service: W700servicesService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private router: Router,
    private service: CommonService, private toastr: ToastrService,
    private _fb: FormBuilder,
    private overlayContainer: OverlayContainer,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private tabChangeService: TabChangeService
  ) {
    this.reactiveFormofname = _fb.group({ ofname: '' });
    this.reactiveFormoforgname = _fb.group({ oforgname: '' });
    this.reactiveFormlabname = _fb.group({ labname: '' });
  }

  Rulelist: any = [];
  routename: string = '';
  pagerolepermisions: any = '';
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  panelOpenState = false;
  RuleIds:string='';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  varuleautocompletecontrol = {
    "LabUIControls": {
      "RuleName": {
        "Displayname": "Rule Name",
        "SearchKey": "",
        "Placeholder": "Search Rule Name",
        "ReferenceObjKey": "",
        "Type": "Text",
        "Required": true,
        "Sequence": 1,
        "isgroupend": true,
        "isdisabled":true
      },
      "TestMode": {
        "Displayname": "Test Mode",
        "SearchKey": "",
        "Placeholder": "Test Mode",
        "Type": "Checkbox",
        "Required": false,
        "Sequence": 2,
        "ReferenceObjKey": "",
        "isgroupend": true,
        "isdisabled":false
      },
      "LabOrgName": {
        "Displayname": "Lab Organization",
        "SearchKey": "LaboratoryOrganizationID",
        "Placeholder": "Search Lab Organization",
        "Type": "Autocomplete",
        "ReferenceObjKey": "LabOrgId",
        "Required": true,
        "Sequence": 3,
        "isgroupend": true,
        "isdisabled":false
      },
      "LabName": {
        "Displayname": "Lab Account",
        "SearchKey": "LaboratoryAccountID",
        "Placeholder": "Search Lab Account",
        "Type": "Autocomplete",
        "ReferenceObjKey": "LabId",
        "Required": true,
        "Sequence": 4,
        "isgroupend": true,
        "isdisabled":false
      },
      "OrdFacOrgName": {
        "Displayname": "Ordering Facility Organization",
        "SearchKey": "OrderingFacilityOrganizationID",
        "Placeholder": "Search Ordering Facility Organization",
        "Type": "Autocomplete",
        "ReferenceObjKey": "OrdFacOrgId",
        "Required": true,
        "Sequence": 5,
        "isgroupend": false,
        "isdisabled":false
      },
      "OrdFacilityName": {
        "Displayname": "Ordering Facility Account",
        "SearchKey": "OrderingFacilityID",
        "Placeholder": "Search Ordering Facility Account",
        "Type": "Autocomplete",
        "Required": true,
        "ReferenceObjKey": "OrdFacilityId",
        "Sequence": 6,
        "isgroupend": false,
        "isdisabled":false
      },
      "ExOrdFacilityName": {
        "Displayname": "Excluded OF Accounts",
        "SearchKey": "ExternalOrderingFacilityID",
        "Placeholder": "Search Excluded OF Accounts",
        "Type": "Multiselect",
        "Required": false,
        "Sequence": 7,
        "ReferenceObjKey": "ExOrdFacilityId",
        "isgroupend": true,
        "isdisabled":false
      },
      "Blank8": {
        "Displayname": "Excluded OF Accounts",
        "SearchKey": "ExternalOrderingFacilityID",
        "Placeholder": "Search Excluded OF Accounts",
        "Type": "Autocomplete",
        "Required": false,
        "Sequence": 8,
        "ReferenceObjKey": "Blank8",
        "isgroupend": true,
        "isdisabled":false
      },
      "OrdPhysicianName": {
        "Displayname": "Ordering Physician",
        "SearchKey": "OrderingPhysician",
        "Placeholder": "Search Ordering Physician",
        "Type": "Autocomplete",
        "ReferenceObjKey": "OrdPhysician",
        "Required": true,
        "Sequence": 9,
        "isgroupend": true,
        "isdisabled":false
      },
      "RefPhysicianName": {
        "Displayname": "Refering Physician",
        "SearchKey": "ReferingPhysician",
        "Placeholder": "Search Refering Physician",
        "Type": "Autocomplete",
        "ReferenceObjKey": "RefPhysician",
        "Required": false,
        "Sequence": 10,
        "isgroupend": true,
        "isdisabled":false
      },
      "PathOrgName": {
        "Displayname": "Pathologist Organization",
        "SearchKey": "PathologistOrganizationID",
        "Placeholder": "Search Pathologist Organization",
        "Type": "Autocomplete",
        "ReferenceObjKey": "PathOrgId",
        "Required": false,
        "Sequence": 11,
        "isgroupend": false,
        "isdisabled":false
      },
      "PathAccountName": {
        "Displayname": "Pathologist Account",
        "SearchKey": "PathologistAccountID",
        "Placeholder": "Search Pathologist Account",
        "Type": "Autocomplete",
        "ReferenceObjKey": "PathAccountId",
        "Required": false,
        "Sequence": 12,
        "isgroupend": false,
        "isdisabled":false
      },
      "PathologistName": {
        "Displayname": "Pathologist",
        "SearchKey": "PathologistID",
        "Placeholder": "Search Pathologist",
        "Type": "Autocomplete",
        "ReferenceObjKey": "PathologistId",
        "Required": false,
        "Sequence": 13,
        "isgroupend": true,
        "isdisabled":false
      },
      "Blank14": {
        "Displayname": "Excluded OF Accounts",
        "SearchKey": "ExternalOrderingFacilityID",
        "Placeholder": "Search Excluded OF Accounts",
        "Type": "Autocomplete",
        "Required": false,
        "Sequence": 14,
        "ReferenceObjKey": "Blank14",
        "isgroupend": true,
        "isdisabled":false
      },
      "CaseTypeDisplayName": {
        "Displayname": "Case Type",
        "SearchKey": "CaseType",
        "Placeholder": "Search Case Type",
        "Type": "Multiselect",
        "Required": false,
        "Sequence": 15,
        "ReferenceObjKey": "CaseType",
        "isgroupend": true,
        "isdisabled":false
      },
      "ExCaseTypesDisplayName": {
        "Displayname": "Excluded Case Types ",
        "SearchKey": "ExCaseType",
        "Placeholder": "Search Excluded Case Types",
        "Type": "Multiselect",
        "Required": false,
        "Sequence": 16,
        "ReferenceObjKey": "ExCaseTypes",
        "isgroupend": true,
        "isdisabled":false
      },
      "ServiceName": {
        "Displayname": "Service",
        "SearchKey": "Services",
        "Placeholder": "Search Service",
        "Type": "Autocomplete",
        "ReferenceObjKey": "Service",
        "Required": false,
        "Sequence": 17,
        "isgroupend": false,
        "isdisabled":false
      },
      "ExServiceName": {
        "Displayname": "Excluded Services",
        "SearchKey": "Exservices",
        "Placeholder": "Search Excluded Services",
        "Type": "Multiselect",
        "ReferenceObjKey": "ExServices",
        "Required": false,
        "Sequence": 18,
        "isgroupend": true,
        "isdisabled":false
      }
    },
    "LabIntegrationUIcontrol": {
      "RuleDesc": {
        "Displayname": "Rule Description",
        "SearchKey": "",
        "Placeholder": "Search Rule Desc",
        "Type": "Textarea",
        "Required": false,
        "Sequence": 1,
        "ReferenceObjKey": "",
        "isgroupend": false,
        "isdisabled":false
      },
      "ModeLabel": {
        "Displayname": "Mode",
        "SearchKey": "Mode",
        "Placeholder": "Search Mode",
        "Type": "Autocomplete",
        "ReferenceObjKey": "Mode",
        "Required": false,
        "Sequence": 3,
        "isgroupend": false,
        "isdisabled":false
      },
      "EntityName": {
        "Displayname": "Entity Name",
        "SearchKey": "EntityName",
        "Placeholder": "Search Entity Name",
        "Type": "Autocomplete",
        "ReferenceObjKey": "",
        "Required": false,
        "Sequence": 18,
        "isgroupend": false,
        "isdisabled":false
      },
      "CaseStatus": {
        "Displayname": "Case Status",
        "SearchKey": "Casestatus",
        "Placeholder": "Search Case Status",
        "Type": "Multiselect",
        "Required": false,
        "Sequence": 17,
        "ReferenceObjKey": "",
        "isgroupend": false,
        "isdisabled":false
      }
    },
    "IgnoredUicontrol": {
      "PrimaryPGPName": {
        "Displayname": "Primary PGP",
        "SearchKey": "PrimaryPGP",
        "Placeholder": "Search Primary PGP",
        "Type": "Autocomplete",
        "ReferenceObjKey": "PrimaryPGP",
        "Required": false,
        "Sequence": 13,
        "isgroupend": false,
        "isdisabled":false
      },
      "SurgicalCenter": {
        "Displayname": "Surgical Center",
        "SearchKey": "",
        "Placeholder": "Search Surgical Center",
        "Type": "Text",
        "Required": false,
        "Sequence": 14,
        "ReferenceObjKey": "",
        "isgroupend": false,
        "isdisabled":true
      },
      "RuleType": {
        "Displayname": "Rule Type",
        "SearchKey": "",
        "Placeholder": "Search Rule Type",
        "Type": "Text",
        "Required": false,
        "Sequence": 22,
        "ReferenceObjKey": "",
        "isgroupend": false,
        "isdisabled":false
      },
      "RuleConfig": {
        "Displayname": "Rule Config",
        "SearchKey": "",
        "Placeholder": "Search Rule Config",
        "Type": "Text",
        "Required": false,
        "Sequence": 23,
        "ReferenceObjKey": "",
        "isgroupend": false,
        "isdisabled":false
      }
    }
  }
  casestatus: any = ['All','Accession',
    'Accessioning QA',
    'Addendum - Pending Sign-Out',
    'Addendum - Pending Tests',
    'Amendment - Pending Sign-Out',
    'Amendment - Pending Tests',
    'Archived',
    'Archived Orders',
    'Assignment',
    'Assignment - Pending Tests',
    'Cancelled',
    'Cancelled Order',
    'Cancelled Requisition',
    'Correction - Pending Sign-Out',
    'Correction - Pending Tests',
    'Deleted',
    'Diagnosis',
    'Diagnosis - Pending Tests',
    'Diagnosis (Sent Out)',
    'Finalized',
    'Finish Case - Pending Tests',
    'Grossing',
    'Kit',
    'MultiTest',
    'New',
    'New Send Out',
    'Order',
    'Pending Finish Case',
    'Pending Rescreen',
    'Pending Rescreen - Pending Tests',
    'Pending Sign-Out',
    'Pending Tests',
    'Processing',
    'Rejected',
    'Rejected Order',
    'Report - Pending Tests',
    'Requisition',
    'Review',
    'Review - Pending Tests',
    'Screening',
    'Screening - Pending Tests',
    'Screening Review',
    'Screening Review - Pending Tests',
    'Send - Out',
    'Send For Consult',
    'Send For Consult - Pending Tests',
    'Sent To Ext Lab',
    'Sent To External System',
    'Sequestered',
    'Supplemental - Pending Acknowledgement']

  varulevaluelist: any = [];
  keywordsearch = "displayname";
  reactiveFormofname: FormGroup;
  reactiveFormoforgname: FormGroup;
  reactiveFormlabname: FormGroup;
  isLoadingofname: boolean = false;
  isLoadingoforgname: boolean = false;
  isLoadinglabname: boolean = false;
  notfounddata: boolean;
  dynamicJSON: inputField[] = [];
  dynamicJSON1: inputField[] = [];
  dynamicJSON2: inputField[] = [];
  varulemodalheight: Number = 480;

  /**
   * ADDITIVE: chip MatAutocomplete (Case Status + API chip fields e.g. Excluded OF Accounts) —
   * was documented as panelClass; Material 16 applies this string via host `[class]` on mat-autocomplete
   * so the overlay panel gets scroll/max-height/z-index SCSS + wheel bridge in VA modal.
   */
  readonly varulesChipMatScrollPanelClass = 'varules-chip-mat-scroll-panel';
  /**
   * Case Status chip autocomplete only: when filter text is empty, overlay gets this class so SCSS
   * can neutralise MDC selected/active primary styling (purple text / “still selected” look after clear).
   */
  readonly varulesCaseStatusAutocompleteEmptyQueryPanelClass =
    'varules-casestatus-autocomplete-empty-query';
  /** Always on Case Status chip panel only — lets SCSS target without affecting other chip autocompletes. */
  readonly varulesCaseStatusOnlyChipPanelClass = 'varules-casestatus-only-chip-panel';

  /**
   * Was: `[panelClass]="…"` returning `string[]` — `panelClass` is not applied by MatAutocomplete in
   * Material 16; panel styling uses host `[class]` → `classList` on the overlay panel.
   * Now: one string for `[class]`; adds empty-query + Case-Status-only marker classes as needed.
   */
  getCaseStatusChipAutocompletePanelClasses(datarow: inputField): string {
    const q = (datarow.suggestionHighlightQuery || '').trim();
    const scroll = this.varulesChipMatScrollPanelClass;
    const only = this.varulesCaseStatusOnlyChipPanelClass;
    // was: if (!q) return [scroll, this.varulesCaseStatusAutocompleteEmptyQueryPanelClass]; return scroll;
    if (!q) {
      return `${scroll} ${only} ${this.varulesCaseStatusAutocompleteEmptyQueryPanelClass}`;
    }
    return `${scroll} ${only}`;
  }

  /**
   * Was: `caseStatusDropdownShowChosenMark(datarow)` returned true only when filter text was non-empty,
   * so ✓ for chip-selected Case Status rows disappeared after clearing the input. Template no longer uses it.
   */

  private varulesChipMatScrollWheelOpenCount = 0;
  private varulesChipMatScrollWheelHandler: ((e: WheelEvent) => void) | null = null;

  onVarulesChipMatScrollPanelOpened(): void {
    this.varulesChipMatScrollWheelOpenCount++;
    if (this.varulesChipMatScrollWheelOpenCount !== 1) {
      return;
    }
    this.varulesChipMatScrollWheelHandler = (e: WheelEvent) => {
      const panel = document.querySelector(
        '.cdk-overlay-container .mat-mdc-autocomplete-panel.varules-chip-mat-scroll-panel'
      ) as HTMLElement | null;
      if (!panel) {
        return;
      }
      const r = panel.getBoundingClientRect();
      const { clientX: x, clientY: y } = e;
      if (x < r.left || x > r.right || y < r.top || y > r.bottom) {
        return;
      }
      const maxScroll = panel.scrollHeight - panel.clientHeight;
      if (maxScroll <= 0) {
        return;
      }
      const prev = panel.scrollTop;
      const next = Math.max(0, Math.min(maxScroll, prev + e.deltaY));
      if (
        next === prev &&
        ((e.deltaY > 0 && prev >= maxScroll - 0.5) ||
          (e.deltaY < 0 && prev <= 0.5))
      ) {
        return;
      }
      panel.scrollTop = next;
      e.preventDefault();
      e.stopPropagation();
    };
    document.addEventListener('wheel', this.varulesChipMatScrollWheelHandler, {
      passive: false,
      capture: true,
    });
  }

  onVarulesChipMatScrollPanelClosed(): void {
    this.varulesChipMatScrollWheelOpenCount = Math.max(
      0,
      this.varulesChipMatScrollWheelOpenCount - 1
    );
    if (this.varulesChipMatScrollWheelOpenCount > 0) {
      return;
    }
    if (this.varulesChipMatScrollWheelHandler) {
      document.removeEventListener('wheel', this.varulesChipMatScrollWheelHandler, {
        capture: true,
      } as AddEventListenerOptions);
      this.varulesChipMatScrollWheelHandler = null;
    }
  }

  ngOnInit() {
    this.Mode=this.inputDataInModalComponent.Mode;
    this.enableedit=this.inputDataInModalComponent.enableedit;
    if (this.service.checksession() == true) {
      if(this.inputDataInModalComponent.isflag){
        this.Rulelist  = this.inputDataInModalComponent.data;
        this.InterfaceName  = this.inputDataInModalComponent.name;

        this.Islocked = this.inputDataInModalComponent.islocked;
        this.isflag = this.inputDataInModalComponent.isflag;
        if(this.Rulelist.length > 0){
          for (let i = 0; i < this.Rulelist.length; i++) {
            this.Rulelist[i]["isEdit"] = false;
          }
        }
      }else{
        this.routename = this.inputDataInModalComponent.routename;
        this.deploymentkey = this.inputDataInModalComponent.deploymentkey;
        this.Islocked = this.inputDataInModalComponent.islocked;
        this.getvarules(this.routename);
        this.loadprerequisite();
      }
    }

    this.tabChangeService.tabChange$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.activeReferenceRule) {
        this.closematmenu(this.activeReferenceRule);
      }
    });
  }
  loadprerequisite() {
    this.ngxUiLoaderService.start();
    let prerequisiteCalls = 0;
    if(this.inputDataInModalComponent.LabOrgId && this.inputDataInModalComponent.LabOrgId!="-1"){
      prerequisiteCalls++;
      this.getvarulesbyfilter(this.inputDataInModalComponent.LabOrgId,'LaboratoryOrganizationID',[],true,false);
   }
    if(this.inputDataInModalComponent.LabId && this.inputDataInModalComponent.LabId!="-1"){
      prerequisiteCalls++;
      this.getvarulesbyfilter(this.inputDataInModalComponent.LabId,'LaboratoryAccountID',[],true,false);
   }
   if(this.inputDataInModalComponent.OrdFacilityId && this.inputDataInModalComponent.OrdFacilityId!="-1"){
      prerequisiteCalls++;
      this.getvarulesbyfilter(this.inputDataInModalComponent.OrdFacilityId,'OrderingFacilityID',[],true,prerequisiteCalls === 0);
   }
   else if(this.inputDataInModalComponent.OrdFacOrgId && this.inputDataInModalComponent.OrdFacOrgId!="-1"){
     prerequisiteCalls++;
     this.getvarulesbyfilter(this.inputDataInModalComponent.OrdFacOrgId,'OrderingFacilityOrganizationID',[],true,prerequisiteCalls === 0);
   }
   if (prerequisiteCalls === 0) {
     this.ngxUiLoaderService.stop();
   }
  }

  savedata(c, closeAfterSave: boolean = false) {

    this.modifyobj(this.dynamicJSON, this.varuleObj);
    this.modifyobj(this.dynamicJSON1, this.varuleObj);
    this.modifyobj(this.dynamicJSON2, this.varuleObj);

    if (this.varuleObj["RuleId"] > 0 &&  !this.validatevaruledata()) {
      this.ngxUiLoaderService.start();
      var apiname = "api/VitalHubDXAPI/updatevarule";
      this.varuleObj['contextid']=this.inputDataInModalComponent.contextid;
      this.varuleObj['username']=JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
       this.w700service.postapi(apiname, this.varuleObj, this.deploymentkey).then(response => {
        if((response['status'] && response['statusText']) || response['statusText'] === "Unknown Error"){
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!","",{ timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
        else{
          this.ngxUiLoaderService.stop();
          if(response["status"].toLowerCase()=="success"){
            this.toastr.success(response["statusmessage"], "", {
              timeOut: 500,
              positionClass: 'toast-bottom-right'
            });
            this.getvarules(this.routename);
            if (closeAfterSave) {
              this.closepopup(c);
            }
          }
          else{
            this.service.copyableToastError(response["statusmessage"]);
          }

        }

       })
    }
    else {
      let result = this.validatevaruledata();
      if (!result) {
        this.ngxUiLoaderService.start();
        // Pass pipeline contextid and logged-in username so CreateVaRule SaveAudit stores under the correct ContextId (same as update path).
        this.varuleObj['contextid'] = this.inputDataInModalComponent.contextid;
        this.varuleObj['username'] = JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
        this.service.postapi("api/VitalHubDXAPI/createvarule", this.varuleObj).then(
          response => {

            if (response["status"] == "success") {
              this.toastr.success("VA Rule created successfully", "", {
                timeOut: 500,
                positionClass: 'toast-bottom-right'
              });
              this.getvarules(this.routename);
              this.closepopup(c);
            } else {
              this.toastr.error("Failed to create VA Rule", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            }
            this.ngxUiLoaderService.stop();

          })
      }
      else {
        this.toastr.warning("Please enter the required fields", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }

    }
  }
  modifyobj(array, obj) {
    for (var i = 0; i < array.length; i++) {
      for (let [key, value] of Object.entries(obj)) {
        if (array[i].ObjKey == key) {
          if (array[i].multiplevalue != '' && array[i].multiplevalue.length > 0) {
            if (array[i].multiplevalue.length == 1) {
              if(array[i].referenceobjkey){
                obj[array[i].referenceobjkey]=array[i].multiplevalue[0].value=="All"?"*":array[i].multiplevalue[0].value;
                // Set display name field (ObjKey) when referenceobjkey exists
                obj[array[i].ObjKey] = array[i].multiplevalue[0].displayname;
              }
              else{
                obj[key] = array[i].multiplevalue[0].value=="All"?"*":array[i].multiplevalue[0].value;
              }
            }
            else {
              if(array[i].referenceobjkey){
                obj[array[i].referenceobjkey]= array[i].multiplevalue.map(ele=>ele.value).join(',');
                // For multiselect, join display names
                obj[array[i].ObjKey] = array[i].multiplevalue.map(ele=>ele.displayname).join(', ');
              }
              else{
                obj[key] = array[i].multiplevalue.map(ele=>ele.value).join(',');
              }

            }
          }
          else {
            if (array[i].referenceobjkey) {
              if (parseInt(array[i].value) >= 0) {
                if (array[i].referenceobjkey != 'ExOrdFacilityId') {
                obj[array[i].referenceobjkey] = array[i].value;
                // Set display name field (ObjKey) when referenceobjkey exists and value is set directly
                // Find displayname from data array
                if(array[i].data && array[i].data.length > 0){
                  let selectedItem = array[i].data.find(item => item.value == array[i].value || item.value == array[i].value.toString());
                  if(selectedItem){
                    obj[array[i].ObjKey] = selectedItem.displayname;
                  }
                }
              }
              }
              else if (array[i].value == "-1") {
                obj[array[i].referenceobjkey] = array[i].value;
            }
            }
            else {
              obj[key] = array[i].value;
            }

          }
        }
      }
    }
  }
  validatevaruledata() {
    let result;
    for (var i = 0; i < this.dynamicJSON.length; i++) {
      if (this.dynamicJSON[i].required && this.dynamicJSON[i].value == '') {
        result = true;
        break;
      }
      else {
        result = false;
      }
    }
    return result;
  }
  // async getdeploymentconfiguration() {
  //   var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
  //    this.service.getapi(apiname).then(response=>{
  //     var configs = JSON.parse(response.responsebody);
  //    return configs;
  //    });

  // }
  closetpopup() {
    if (this.activeReferenceRule) {
      this.closematmenu(this.activeReferenceRule);
    }
    this.activeModal.close();
    this.varuleObj={};
    this.LabId="";
    this.LabName="";
    this.LabOrgId="";
    this.LabOrgName="";
    this.OrdFacOrgId="";
    this.OrdFacOrgName="";
    this.OrdFacilityId="";
    this.OrdFacilityName="";
    this.dynamicJSON = [];
    this.dynamicJSON1=[];
    this.dynamicJSON2=[];
  }

  searchvalue: string = '';

  deploymentkey: string = ''

  private isWildcardVaruleId(id: any): boolean {
    const value = (id ?? '').toString().trim();
    return !value || value === '-1';
  }

  private formatVaruleFilterDisplayName(displayname: string): string {
    if (displayname === 'All') {
      return 'All(-1)';
    }
    return displayname;
  }

  private findVaruleFilterMatch(results: any[], id: string): any | null {
    if (!results?.length) {
      return null;
    }
    const normalizedId = id.toString().trim();
    return results.find(item => item?.value?.toString() === normalizedId) ?? results[0];
  }

  private resolveVaruleFilterDisplayName(filtertype: string, filtervalue: string): Promise<string> {
    const val = (filtervalue ?? '').toString().trim();
    if (!val || val.length < 3) {
      return Promise.resolve('');
    }
    const apiname = `api/VitalHubDXAPI/getvarulesbyfilter?filtertype=${filtertype}&filtervalue=${val}`;
    return new Promise(resolve => {
      this.w700service.getapi(apiname, this.deploymentkey).subscribe({
        next: (response: any) => {
          if (!response?.length) {
            resolve('');
            return;
          }
          const match = this.findVaruleFilterMatch(response, val);
          resolve(match ? this.formatVaruleFilterDisplayName(match.displayname) : '');
        },
        error: () => resolve('')
      });
    });
  }

  private applyResolvedNameToMatchingRules(
    filtertype: string,
    resolvedId: string,
    displayname: string
  ): void {
    if (!displayname || !this.Rulelist?.length) {
      return;
    }
    const normalizedId = resolvedId.toString().trim();
    for (const rule of this.Rulelist) {
      if (filtertype === 'LaboratoryAccountID' && rule.LabId?.toString() === normalizedId && !rule.LabName?.trim()) {
        rule.LabName = displayname;
      }
      if (filtertype === 'LaboratoryOrganizationID' && rule.LabOrgId?.toString() === normalizedId && !rule.LabOrgName?.trim()) {
        rule.LabOrgName = displayname;
      }
      if (filtertype === 'OrderingFacilityID' && rule.OrdFacilityId?.toString() === normalizedId && !rule.OrdFacilityName?.trim()) {
        rule.OrdFacilityName = displayname;
      }
      if (filtertype === 'OrderingFacilityOrganizationID' && rule.OrdFacOrgId?.toString() === normalizedId && !rule.OrdFacOrgName?.trim()) {
        rule.OrdFacOrgName = displayname;
      }
    }
    this.cdr.markForCheck();
  }

  async enrichRuleDisplayNames(rule: any): Promise<void> {
    if (!rule) {
      return;
    }
    const lookups: Promise<void>[] = [];

    if (!this.isWildcardVaruleId(rule.LabOrgId) && !rule.LabOrgName?.trim()) {
      lookups.push(
        this.resolveVaruleFilterDisplayName('LaboratoryOrganizationID', rule.LabOrgId).then(name => {
          if (name) {
            rule.LabOrgName = name;
          }
        })
      );
    }
    if (!this.isWildcardVaruleId(rule.LabId) && !rule.LabName?.trim()) {
      lookups.push(
        this.resolveVaruleFilterDisplayName('LaboratoryAccountID', rule.LabId).then(name => {
          if (name) {
            rule.LabName = name;
          }
        })
      );
    }
    if (!this.isWildcardVaruleId(rule.OrdFacOrgId) && !rule.OrdFacOrgName?.trim()) {
      lookups.push(
        this.resolveVaruleFilterDisplayName('OrderingFacilityOrganizationID', rule.OrdFacOrgId).then(name => {
          if (name) {
            rule.OrdFacOrgName = name;
          }
        })
      );
    }
    if (!this.isWildcardVaruleId(rule.OrdFacilityId) && !rule.OrdFacilityName?.trim()) {
      lookups.push(
        this.resolveVaruleFilterDisplayName('OrderingFacilityID', rule.OrdFacilityId).then(name => {
          if (name) {
            rule.OrdFacilityName = name;
          }
        })
      );
    }

    await Promise.all(lookups);
  }

  private async enrichRulelistDisplayNames(rules: any[]): Promise<void> {
    if (!rules?.length) {
      return;
    }
    await Promise.all(rules.map(rule => this.enrichRuleDisplayNames(rule)));
    this.cdr.markForCheck();
  }

  getvarules(rulename) {
    this.ngxUiLoaderService.start();
    var apiname = "api/VitalHubDXAPI/getvarule?RuleName=" + rulename;
    this.w700service.getapi(apiname, this.deploymentkey).subscribe({
      next: async data => {
        this.Rulelist = data as any[];
        if (data.length > 0) {
          for (let i = 0; i < this.Rulelist.length; i++) {
            this.Rulelist[i]["isEdit"] = false;
          }
          await this.enrichRulelistDisplayNames(this.Rulelist);
        }
        this.ngxUiLoaderService.stop();
      },
      error: () => {
        this.ngxUiLoaderService.stop();
      }
    });

  }


  currentlyOpenedItemIndex = -1;

  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
    if (this.activeReferenceRule === this.Rulelist[itemIndex]) {
      this.closematmenu(this.activeReferenceRule);
    }
  }

  openrule(data,modal) {
    if (this.activeReferenceRule) {
      return;
    }
    const modalRef = this.modalService.open(modal,
      { windowClass: "myCustomModalClassaddvarule", backdrop: 'static', keyboard: false });
    this.currentModalRefs.push(modalRef);
    
    modalRef.result.then(() => {
      this.modalWasOpen = false;
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    }, (reason) => {
      this.modalWasOpen = false;
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-varules-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-varules-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
    this.varuleObj = {};
    if (data) {
      this.varuleObj = JSON.parse(JSON.stringify(data));
      this.rulename = this.varuleObj["RuleName"];
      this.RuleIds=this.varuleObj["RuleId"];
      const setupEditControls = () => {
        this.dynamicJSON = [];
        this.dynamicJSON1 = [];
        this.dynamicJSON2 = [];
        this.setUicontrol('LabUIControls', this.dynamicJSON, this.varuleObj);
        this.setUicontrol('LabIntegrationUIcontrol', this.dynamicJSON1, this.varuleObj);
        this.setUicontrol('IgnoredUicontrol', this.dynamicJSON2, this.varuleObj);
        this.cdr.markForCheck();
      };
      const needsNameEnrichment =
        (!this.varuleObj.LabOrgName?.trim() && !this.isWildcardVaruleId(this.varuleObj.LabOrgId)) ||
        (!this.varuleObj.LabName?.trim() && !this.isWildcardVaruleId(this.varuleObj.LabId)) ||
        (!this.varuleObj.OrdFacOrgName?.trim() && !this.isWildcardVaruleId(this.varuleObj.OrdFacOrgId)) ||
        (!this.varuleObj.OrdFacilityName?.trim() && !this.isWildcardVaruleId(this.varuleObj.OrdFacilityId));
      if (needsNameEnrichment) {
        void this.enrichRuleDisplayNames(this.varuleObj).then(() => setupEditControls());
      } else {
        setupEditControls();
      }
    }
    else {

      let varuleobj: varule = {
        RuleName: this.routename,
        RuleDesc: '',
        CaseType: '*',
        Service: '-1',
        RuleType: '1',
        Status: '2',
        LabId: '',
        CaseId: '-1',
        LabOrgId:'',
        OrdFacilityId:'',
        OrdFacOrgId: '',
        PathologistId: '-1',
        PathOrgId: '-1',
        PathAccountId: '',
        OrdPhysician: '-1',
        RefPhysician: '-1',
        RefPhysicianName: 'All(-1)',
        EntityName: '',
        Mode: '',
        TestMode: 'False',
        SurgicalCenter: '-1',
        parentruleid: '',
        CaseStatus: 'All',
        ExServices: '',
        ExCaseTypes: '',
        CreatedBy: '',
        RuleConfig: '-1',
        RuleId: 0,
        ExOrdFacilityId: '',
        PrimaryPGP: '-1',
        PrimaryPGPName:'All(-1)',
        ModifiedBy: '',
        LabName:'',
        LabOrgName: '',
        OrdFacilityName: '',
        OrdFacOrgName: '',
        PathologistName: 'All(-1)',
        PathOrgName: 'All(-1)',
        PathAccountName: 'All(-1)',
        OrdPhysicianName: 'All(-1)',
        CaseTypeDisplayName: 'All',
        statusmessage: '',
        ModeLabel:'',
        ExCaseTypesDisplayName:'',
        ServiceName:'All(-1)',
        ExServiceName:'',
        ExOrdFacilityName:'',
        deploymentkey :this.deploymentkey
      };
      if(this.inputDataInModalComponent.LabOrgId && this.inputDataInModalComponent.LabOrgId!="-1"){
        varuleobj.LabId="-1";
        varuleobj.LabName="All(-1)"
        varuleobj.LabOrgId=this.LabOrgId;
        varuleobj.LabOrgName=this.LabOrgName;
     }
    else  if(this.inputDataInModalComponent.LabId&&this.inputDataInModalComponent.LabId!="-1"){
       varuleobj.LabOrgId="-1";
       varuleobj.LabOrgName="All(-1)";
       varuleobj.LabId=this.LabId;
       varuleobj.LabName=this.LabName;
     }
     if(this.inputDataInModalComponent.OrdFacilityId&&this.inputDataInModalComponent.OrdFacilityId!="-1"){
        varuleobj.OrdFacOrgId="-1";
        varuleobj.OrdFacOrgName="All(-1)";
        varuleobj.OrdFacilityId=this.OrdFacilityId;
        varuleobj.OrdFacilityName=this.OrdFacilityName;
     }
     else if(this.inputDataInModalComponent.OrdFacOrgId&&this.inputDataInModalComponent.OrdFacOrgId!="-1"){
        varuleobj.OrdFacilityId="-1";
        varuleobj.OrdFacilityName="All(-1)";
        varuleobj.OrdFacOrgId=this.OrdFacOrgId;
        varuleobj.OrdFacOrgName=this.OrdFacOrgName;
     }
     varuleobj.Mode=this.Mode;
      this.varuleObj=varuleobj;
      this.dynamicJSON = [];
      this.dynamicJSON1 = [];
      this.dynamicJSON2 = [];
      this.setUicontrol('LabUIControls', this.dynamicJSON, this.varuleObj);
      this.setUicontrol('LabIntegrationUIcontrol', this.dynamicJSON1, this.varuleObj);
      this.setUicontrol('IgnoredUicontrol', this.dynamicJSON2, this.varuleObj);
    }

  }

  getresultsData(result,iscompleted,filtertype){
    if(result.length>0 && filtertype){
      if(result[0].displayname=="All"){
        result[0].displayname+='(-1)';
      }
      const resolvedId = result[0].value?.toString() ?? '';
      const resolvedName = result[0].displayname;
      if(filtertype=="LaboratoryAccountID"){
        this.LabId=result[0].value;
        this.LabName=resolvedName;
      }
      if(filtertype=="LaboratoryOrganizationID"){
        this.LabOrgId=result[0].value;
        this.LabOrgName=resolvedName;
      }
      if(filtertype=="OrderingFacilityID"){
        this.OrdFacilityId=result[0].value;
        this.OrdFacilityName=resolvedName;
      }
      if(filtertype=="OrderingFacilityOrganizationID"){
        this.OrdFacOrgId=result[0].value;
        this.OrdFacOrgName=resolvedName;
      }
      this.applyResolvedNameToMatchingRules(filtertype, resolvedId, resolvedName);
      if(iscompleted){
        this.ngxUiLoaderService.stop();
      }
     }
  }
  setUicontrol(objkey, array, obj) {
    let count = 0;
    let formcontrolname = ''
    for (let [key, value] of Object.entries(obj)) {
      for (let [data1, objvalue] of Object.entries(this.varuleautocompletecontrol[objkey])) {
        if (data1 == key || (data1 == "Blank" + objvalue["Sequence"])) {
          if(data1=='Service'&&value=='-1'){
            value='ALL (-1)'
          }
          let reactiveFormprocess: FormGroup;
          formcontrolname = 'prop' + count++;
          if (objvalue["Type"] == "Autocomplete" && value) {
            reactiveFormprocess = this._fb.group({ [formcontrolname]: value });
          }
          else {
            reactiveFormprocess = this._fb.group({ [formcontrolname]: '' });
          }

          if ("SurgicalCenter" == key) {
            value = -1;
          }

          let multivalue = [];
          if (objvalue["Type"] == 'Multiselect' && value) {
            if (value == "*") {
              value = "All";
              let obj={
                displayname:"All",
                value:"*"
              }
              multivalue.push(obj)
            }
            else if (value.toString().indexOf(",") > 0) {
              var arrvalue= value.toString().split(",");
              if(objvalue["ReferenceObjKey"]){
                  var objectvalue=obj[objvalue["ReferenceObjKey"]];
                if (objectvalue !== objectvalue + ',') {
                  objectvalue = objectvalue + ','
                }
                  if(objectvalue.toString().indexOf(",")>0){
                    var arr= objectvalue.toString().split(",");
                    arrvalue.forEach(va=>{
                      if(va.trim()){
                        arr.forEach(data=>{
                          let obj={
                            displayname:va,
                            value:data
                          }
                          let existvalue=multivalue.filter(ele=>ele.value===data);
                          let existdisplayname=multivalue.filter(ele=>ele.displayname===va);
                          if(existvalue.length==0 && existdisplayname.length==0){
                            multivalue.push(obj)
                          }
                        })
                      }
                    })
                  }
                  else{
                    arrvalue.forEach(va=>{
                      if(va.trim()){
                        let obj={
                          displayname:va,
                          value:va
                        }
                        multivalue.push(obj)
                      }

                    })
                  }

              }
              else{
                arrvalue.forEach(va=>{
                  if(va.trim()){
                    let obj={
                      displayname:va,
                      value:va
                    }
                    multivalue.push(obj)
                  }
                })
              }

            }
            else{
              let object={
                displayname:value,
                value:objvalue["ReferenceObjKey"]?obj[objvalue["ReferenceObjKey"]]:value
              }
              multivalue.push(object);
            }

          }
          let inputValue: inputField = {
            data: objvalue["SearchKey"] == 'Casestatus' ? this.casestatus : '',
            suggestionHighlightQuery: '',
            formcontrolname: formcontrolname,
            formgroupname: reactiveFormprocess,
            isKey: objvalue["SearchKey"],
            label: objvalue["Displayname"],
            placeholder: objvalue["Placeholder"],
            isloading: false,
            type: objvalue["Type"],
            value: value ? value.toString() : '',
            multiplevalue: multivalue.length > 0 ? multivalue : '',
            formcontrol: new FormControl(),
            sequence: objvalue["Sequence"],
            ObjKey: key,
            required: objvalue["Required"],
            referenceobjkey: objvalue["ReferenceObjKey"],
            isgroupend: objvalue["isgroupend"],
            isdisabled:objvalue["isdisabled"]
          }
          if (data1 == ("Blank" + objvalue["Sequence"])) {
            if (!this.checkexistblankkey(array, data1)) {
              array.push(inputValue);
              reactiveFormprocess.patchValue({
                formcontrolname: value
              });
            }
          }
          else {
            array.push(inputValue);
            reactiveFormprocess.patchValue({
              formcontrolname: value
            });
          }

        }
      }
      if (array.length > 0) {
        array = this.sortByKey(array, 'sequence')
      }
    }
  }
  checkexistblankkey(array: any, key: string) {
    let isfoundkey = false;
    if (array.length > 0) {
      array.forEach(element => {
        if (element.referenceobjkey == key) {
          isfoundkey = true;
        }
      });
    }
    return isfoundkey;
  }
  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  /**
   * Split option label into plain / bold segments for mat-option (avoid [innerHTML] — MDC strips it).
   */
  /** Normalize API row or chip string option for suggestion label / bold segments. */
  optionDisplayLabel(row: any): string {
    if (row == null || row === '') {
      return '';
    }
    if (typeof row !== 'object') {
      return String(row);
    }
    const v = row.displayname ?? row.DisplayName ?? row.displayName;
    return v != null ? String(v) : '';
  }

  multiselectSuggestionSegments(
    displayLabel: string | undefined | null,
    query: string | undefined
  ): { text: string; bold: boolean }[] {
    const label = displayLabel != null ? String(displayLabel) : '';
    const q = (query || '').trim();
    if (!label) {
      return [];
    }
    if (!q) {
      return [{ text: label, bold: false }];
    }
    const lowerLabel = label.toLowerCase();
    const lowerQ = q.toLowerCase();
    const segments: { text: string; bold: boolean }[] = [];
    let lastIndex = 0;
    let idx = lowerLabel.indexOf(lowerQ, lastIndex);
    while (idx !== -1) {
      if (idx > lastIndex) {
        segments.push({ text: label.slice(lastIndex, idx), bold: false });
      }
      segments.push({ text: label.slice(idx, idx + q.length), bold: true });
      lastIndex = idx + q.length;
      idx = lowerLabel.indexOf(lowerQ, lastIndex);
    }
    if (lastIndex < label.length) {
      segments.push({ text: label.slice(lastIndex), bold: false });
    }
    return segments.length ? segments : [{ text: label, bold: false }];
  }

  setValue(data, Event) {
    data.RuleDesc = '';
    if(Event.checked){
      data.Status="1"
    }
    else{
      data.Status="2";
    }
  }

  onVaruleToggleChange(data, event, anchor: HTMLElement) {
    if (this.activeReferenceRule) {
      return;
    }
    this.setValue(data, event);
    this.activeReferenceRule = data;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.attachReferenceOverlayToBody();
      this.positionReferencePanel(anchor);
    });
  }

  private attachReferenceOverlayToBody() {
    const backdrop = this.referenceBackdropTpl?.nativeElement;
    const panel = this.referencePanelTpl?.nativeElement;
    if (backdrop && backdrop.parentElement !== document.body) {
      this.renderer.appendChild(document.body, backdrop);
    }
    if (panel && panel.parentElement !== document.body) {
      this.renderer.appendChild(document.body, panel);
    }
  }

  private positionReferencePanel(anchor: HTMLElement) {
    requestAnimationFrame(() => {
      const rect = anchor.getBoundingClientRect();
      this.referencePanelTop = rect.bottom + 8;
      this.referencePanelLeft = Math.max(8, rect.right - this.referencePanelWidth);
      this.cdr.detectChanges();
    });
  }

  private closeReferencePanel() {
    this.activeReferenceRule = null;
    this.cdr.detectChanges();
  }

  private removeReferenceOverlayFromBody() {
    const backdrop = this.referenceBackdropTpl?.nativeElement;
    const panel = this.referencePanelTpl?.nativeElement;
    if (backdrop?.parentNode) {
      this.renderer.removeChild(backdrop.parentNode, backdrop);
    }
    if (panel?.parentNode) {
      this.renderer.removeChild(panel.parentNode, panel);
    }
  }
  /** Refocus / reopen chip field: sync highlight + reload suggestions (Case Status string list + API chip fields). */
  onVarulesMultiselectChipFocus(datarow: inputField): void {
    if (datarow.type !== 'Multiselect') {
      return;
    }
    const el = document.getElementById(datarow.formcontrolname) as
      | HTMLInputElement
      | null;
    const v = el?.value != null ? String(el.value) : '';
    datarow.suggestionHighlightQuery = v.trim();
    this.getvarulesbyfilter(v, datarow.isKey, datarow, false, false);
  }

  /** Chip multiselect: MatOption cannot show ✓ for chosen chips — custom mark; supports string options (Case Status). */
  multiselectOptionInChips(
    data: { value?: string } | string | null | undefined,
    datarow: inputField
  ): boolean {
    if (
      datarow.type !== 'Multiselect' ||
      !datarow.multiplevalue ||
      !Array.isArray(datarow.multiplevalue)
    ) {
      return false;
    }
    const optVal =
      data === null || data === undefined
        ? ''
        : typeof data === 'object'
          ? String((data as { value?: string }).value)
          : String(data);
    if (optVal === '') {
      return false;
    }
    return datarow.multiplevalue.some(
      (v: { value?: string }) =>
        v != null && String(v.value) === optVal
    );
  }

  getvarulesbyfilter(event, filtertype, array,findSpecificid,iscompleted) {
    var val = event;
    if (
      !findSpecificid &&
      array &&
      typeof array === 'object' &&
      typeof (array as inputField).formcontrolname === 'string' &&
      (array as inputField).type === 'Multiselect' &&
      (array as inputField).isKey !== 'Casestatus'
    ) {
      (array as inputField).suggestionHighlightQuery =
        val != null && val !== undefined ? String(val).trim() : '';
    }
    const trimVal =
      val != null && val !== undefined ? String(val).trim() : '';
    if(!findSpecificid){
      array.isloading = true;
    }
    else{
      this.ngxUiLoaderService.start();
    }
    if (filtertype === 'Casestatus' && !findSpecificid) {
      array.isloading = false;
      const q = (val != null && val !== undefined ? String(val) : '').trim().toLowerCase();
      array.data = !q
        ? [...this.casestatus]
        : this.casestatus.filter((item: string) =>
            String(item).toLowerCase().includes(q)
          );
      (array as inputField).suggestionHighlightQuery =
        val != null && val !== undefined ? String(val).trim() : '';
      this.notfounddata = array.data.length === 0;
      this.cdr.markForCheck();
      return;
    }
    // Reload full suggestion list when chip input is cleared (API-backed multiselect fields only).
    if (
      !findSpecificid &&
      filtertype !== 'Casestatus' &&
      trimVal === '' &&
      array &&
      typeof array === 'object' &&
      typeof (array as inputField).formcontrolname === 'string' &&
      (array as inputField).type === 'Multiselect'
    ) {
      array.isloading = true;
      var apinameEmpty = `api/VitalHubDXAPI/getvarulesbyfilter?filtertype=${filtertype}&filtervalue=`;
      this.w700service.getapi(apinameEmpty, this.deploymentkey).subscribe(
        (response) => {
          if (response) {
            array.data = response as any[];
            array.isloading = false;
            if (array.data.length > 0) {
              if (
                array.data[array.data.length - 1].displayname.toLowerCase() ==
                'all'
              ) {
                array.data.unshift(array.data.pop());
              }
            }
            if (array.length == 0) {
              this.notfounddata = true;
            } else {
              this.notfounddata = false;
            }
            this.cdr.markForCheck();
          } else {
            array.isloading = false;
            this.cdr.markForCheck();
          }
        },
        () => {
          array.isloading = false;
          this.cdr.markForCheck();
        }
      );
      return;
    }
    // if (val && val.length >= 3 && filtertype != 'Casestatus') {
    if (val && val.length >= 3) {
      var apiname = `api/VitalHubDXAPI/getvarulesbyfilter?filtertype=${filtertype}&filtervalue=` + val;
      this.w700service.getapi(apiname, this.deploymentkey).subscribe(response => {
        if (response) {
          if(findSpecificid){
          this.getresultsData(response,iscompleted,filtertype);
          }
          else{
            array.data = response as any[];
            array.isloading = false;
            if(array.data.length>0){
              if(array.data[array.data.length-1].displayname.toLowerCase()=="all"){
                array.data.unshift(array.data.pop());
              }
            }
            if (array.length == 0) {
              this.notfounddata = true;
            }
            else {
              this.notfounddata = false;
            }
            this.cdr.markForCheck();
          }

        }
      })
    } else if (!findSpecificid) {
      array.isloading = false;
    }
    if(findSpecificid){
      // return findSpecificArray;
    }
  }
  searchvarulefilterCleared(event, array) {
    array.suggestionHighlightQuery = '';
    // array.data = [];
    array.data = array.isKey === 'Casestatus' ? [...this.casestatus] : [];
    array.multiplevalue = '';
    for (let [key, value] of Object.entries(this.varuleObj)) {
      let val = [value].toString();
      if (key == array.ObjKey || key == array.referenceobjkey) {
        this.varuleObj[key] = '';
  }
      array.value = '';
    }
  }

  hideSuccessMessage = false;
  resetvarule(data) {
    data.isEdit = false;
  }

 async changeVaruleStatus(data) {
    this.ngxUiLoaderService.start();
    if (data && data.RuleDesc != '') {
      let apicntrl = '';
      let auditvalue='';
      let oldauditvalue='';
      if (data.Status=="1") {
        apicntrl = 'activatevarule';
        auditvalue='VA Rule Activated';
        oldauditvalue='VA Rule Deactivated';
      }
      else {
        apicntrl = 'deactivatevarule';
        auditvalue='VA Rule Deactivated';
        oldauditvalue='VA Rule Activated';
      }

      var validateresponse = await this.w700service.postapi(`api/VitalHubDXAPI/${apicntrl}`, data, this.deploymentkey);
      if (validateresponse['status'] && validateresponse['statusText']) {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Failed to update varule", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
        this.closeReferencePanel();
      }
      else {
        this.ngxUiLoaderService.stop();
        this.toastr.success("VA Rule saved successfully", "", {
          timeOut: 500,
          positionClass: 'toast-bottom-right'
        });
        this.service.auditsave("Update",oldauditvalue,auditvalue,"Pipeline",this.inputDataInModalComponent.contextid,"VA Rule Status Updated successfully")
        this.closeReferencePanel();
      }
    }
    else {
      this.ngxUiLoaderService.stop();   
      this.toastr.warning('Please add the Reference!!', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }
  buildtitle(data) {
    return data.Status == '1' ? 'Active varule' : 'Passive varule';
  }
  addfiltervalue(event, data) {
    data.value = event.value;
    if (data.referenceobjkey) {
      data.multiplevalue = [{
        displayname: event.displayname || event.value,
        value: event.value
      }];
    }
  }
  closepopup(c) {
    c('close modal');
    this.varuleObj={};
    this.dynamicJSON = [];
    this.dynamicJSON1=[];
    this.dynamicJSON2=[];
  }
  remove(data: string, array): void {
    const index = array.findIndex(va => va.displayname == data);
    if (index >= 0) {
      if (data.length == 1) {
        this.removeonevalue(data);
      }
      else {
        this.removeValueFromObject(data);
      }
      array.splice(index, 1);
    }
  }
  removeonevalue(data: string) {
    for (let [key, value] of Object.entries(this.varuleObj)) {
      let val = [value].toString();
      if (key == 'ExServices') {
        let splivalue = val.split(",")
        this.varuleObj[key] = '';
        splivalue.forEach(element => {
          if (element !== data) {
            if (element !== '') {
              if (element.includes(',')) {
                this.varuleObj[key] += element;
              }
              else {
                this.varuleObj[key] += element + ',';
              }
            }
          }
        });
      }
    }
  }
  removeValueFromObject(valueToRemove: string): void {
    if (valueToRemove.includes('(')) {
      let splitdata = valueToRemove.split("(")
      valueToRemove = splitdata[1].substring(0, splitdata[1].length - 1)
    }
    for (let [key, value] of Object.entries(this.varuleObj)) {
      let val = [value].toString();
      if (val.includes(valueToRemove)) {
        let splivalue = val.split(",")
        this.varuleObj[key] = '';
        if(key=='ExCaseTypes' || key=='ExCaseTypesDisplayName'){
          this.varuleObj['ExCaseTypesDisplayName'] = '';
          this.varuleObj['ExCaseTypes'] = '';
        }
        if(key=='ExServiceName' || key=='ExServices')
        {
          this.varuleObj['ExServiceName'] = '';
          this.varuleObj['ExServices'] = '';
        }
        if(key=='CaseTypeDisplayName' || key=='CaseType')
        {
          this.varuleObj['CaseTypeDisplayName'] = '';
          this.varuleObj['CaseType'] = '';
        }
        splivalue.forEach(element => {
          if (!element.includes(valueToRemove)) {
            if (element !== '') {
              if (element.includes(',')) {
                this.varuleObj[key] += element;
              }
              else {
                this.varuleObj[key] += element + ',';
              }
            }
          }
        });
      }
    }
  }  
  selected(event, datarow) {
    if (event.option.viewValue == 'All' || event.option.viewValue =='All [*]') {
      datarow.multiplevalue = [];
    }
    if (datarow.multiplevalue.length>0) {

      let exists = datarow.multiplevalue.filter(va => (va.value === 'All' || va.value==="*"));
      if (exists.length > 0) {
        this.toastr.warning((exists[0].value=="*"?"All": exists[0].value) + " " + "option includes every case status for the lab account", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      else {
        let exist = datarow.multiplevalue.filter(va => va.value === event.option.value);
        if (exist.length > 0) {
          this.toastr.warning(exist[0].value+ " " + 'Already Exist', "", {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
        else {
          var obj={
            displayname:event.option.viewValue,
            value:event.option.value
          }
          datarow.multiplevalue.push(obj);
          datarow.formcontrol.setValue(null);
        }
      }
    }
    else {
      datarow.multiplevalue = [];
      var obj={
        displayname:event.option.viewValue,
        value:event.option.value
      }
      datarow.multiplevalue.push(obj);
      datarow.formcontrol.setValue(null);
    }
    if(datarow.ObjKey!="CaseStatus"){
      datarow.data = [];
    }
    // let ele = document.getElementById(datarow.formcontrolname);
    // ele.innerText = '';
    // ele.focus();
    // ele.blur();
    this.clearMultiselectChipInputAfterOption(datarow);

  }

  /** Clears typed search text after an option is chosen (chip input + highlight state). */
  private clearMultiselectChipInputAfterOption(datarow: inputField): void {
    datarow.suggestionHighlightQuery = '';
    datarow.formcontrol.setValue(null);
    const el = document.getElementById(datarow.formcontrolname) as HTMLInputElement | null;
    if (el) {
      el.value = '';
    }
    if (datarow.isKey === 'Casestatus') {
      datarow.data = [...this.casestatus];
    }
    this.cdr.markForCheck();
  }
  add(event: MatChipInputEvent, control): void {
    event.input.value = "";
  }
  setAll(ischecked, data) {
    if (ischecked) {
      data.value = "True"
    }
    else {
      data.value = "False"
    }
  }
  closematmenu(data){
    this.closeReferencePanel();
    data.Status=data.Status=="1"?"2":"1";
  }
  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  ngOnDestroy() {
    this.removeReferenceOverlayFromBody();
    this.varulesChipMatScrollWheelOpenCount = 0;
    if (this.varulesChipMatScrollWheelHandler) {
      document.removeEventListener('wheel', this.varulesChipMatScrollWheelHandler, {
        capture: true,
      } as AddEventListenerOptions);
      this.varulesChipMatScrollWheelHandler = null;
    }
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
  }
}

export interface inputField {
  data: any;
  formgroupname: FormGroup,
  formcontrolname: string;
  isKey: string,
  label: string,
  placeholder: string,
  isloading: boolean;
  type: string;
  value: string;
  multiplevalue: any;
  formcontrol: FormControl;
  sequence: Number;
  ObjKey: string;
  required: boolean;
  referenceobjkey: string;
  isgroupend: boolean;
  isdisabled:boolean;
  /** Current chip-input text for bolding matching substrings in mat-autocomplete suggestions (Multiselect). */
  suggestionHighlightQuery?: string;
}
export interface varule {
  RuleName: string;
  RuleDesc: string;
  CaseType: string;
  Service: string;
  RuleType: string;
  Status: string;
  LabId: string;
  CaseId: string;
  LabOrgId: string;
  OrdFacilityId: string;
  OrdFacOrgId: string;
  PathologistId: string;
  PathOrgId: string;
  PathAccountId: string;
  OrdPhysician: string;
  RefPhysician: string;
  RefPhysicianName: string;
  EntityName: string;
  Mode: string;
  TestMode: string;
  SurgicalCenter: string;
  parentruleid: string;
  CaseStatus: string;
  ExServices: string;
  ExCaseTypes: string;
  CreatedBy: string;
  RuleConfig: string;

  RuleId: Number;
  ExOrdFacilityId: string;
  PrimaryPGP: string;
  ModifiedBy: string;

  LabName: string;
  LabOrgName: string;
  OrdFacilityName: string;
  OrdFacOrgName: string;
  PathologistName: string;
  PathOrgName: string;
  PathAccountName: string;
  OrdPhysicianName: string;
  CaseTypeDisplayName: string;
  statusmessage: string;
  ModeLabel:string;
  ExServiceName:string;
  ServiceName:string;
  ExOrdFacilityName:string;
  ExCaseTypesDisplayName:string;
  PrimaryPGPName:string;
  deploymentkey?: string;
}


